window.loadCountdown = (() => {
    let scriptLoadPromise = null;

    return function () {
        if (document.getElementById('countdown-script')) {
            return scriptLoadPromise || Promise.resolve();
        }

        scriptLoadPromise = new Promise((resolve, reject) => {
            const script = Object.assign(document.createElement('script'), {
                src: '/build/assets/static/countdown.js',
                id: 'countdown-script',
                onload: resolve,
                onerror: reject,
            });

            document.head.appendChild(script);
        });

        return scriptLoadPromise;
    };
})();

Alpine.data("countdownAlpine", (timestamp, units = 'countdown.DEFAULT', max = NaN, digits = 0) => ({
    timestamp: timestamp,
    units: units,
    max: max,
    digits: digits,
    countdown: null,

    init() {
        this.update();

        setInterval(() => {
            this.update();
        }, 500);
    },

    update() {
        loadCountdown().then(() => {
            this.countdown = countdown(
                new Date(this.timestamp * 1000),
                null,
                countdown.MONTHS | countdown.WEEKS | countdown.DAYS | countdown.HOURS | countdown.MINUTES,
                this.max,
                this.digits
            );
        });
    }
}));
